export const DE_FORM: { [propKey: string]: any } = {
    start_initial_form_dialogue_de: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Hallo, ich verstehe Sie möchten sich zur Arbeitssuche oder Berufsausbildung in Deutschland beraten lassen. Der Beratungstermin findet vor Ort in Ihrem zuständigen Jobcenter statt. Der Termin ist freiwillig und kostenlos.<br><br>Für Ihren Termin brauchen wir einige Informationen von Ihnen. Beispielsweise zu Ihrem Lebenslauf und zu Ihren Qualifikationen.",
            },
            {
                type: "defaultText",
                text: "Um sicher zu gehen, dass Sie den richtigen Fragebogen ausfüllen habe ich vorab noch ein paar Fragen an Sie.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Ok",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ok",
                            payload: "is_refugee",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    is_refugee: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Sind Sie vor dem Krieg in der Ukraine geflohen und suchen in Deutschland Schutz?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Refugee",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ja",
                            payload: "form_initial_address",
                            type: "button",
                            theme: "left",
                        },
                        {
                            title: "Nein",
                            payload: "no_refugee",
                            type: "button",
                            theme: "right",
                        },
                    ],
                },
            ],
        },
    },
    form_initial_address: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Um festzustellen, ob wir für Sie die richtigen Ansprechpartner für die Arbeits- und Berufsberatung sind und damit wir Sie gegebenfalls zukünftig kontaktieren können brauche ich Ihre (aktuelle) Wohnadresse in Deutschland.",
                info: "Die vollständige Adresse ist wichtig, um Sie dem richtigen Jobcenter zuordnen zu können. Denn Bewohner/innen einer Straße werden teils unterschiedlichen Jobcentern zugeordnet je nach Hausnummer.<br><br>Sollte sich Ihre Wohnadresse in Zukunft ändern, können Sie das online auf unserer Seite Veränderungen mitteilen angeben.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Straße",
                    type: "formInput",
                },
                {
                    name: "Hausnummer",
                    type: "formInput",
                },
                {
                    name: "Adresszusatz",
                    type: "formInput",
                },
                {
                    name: "Postleitzahl",
                    type: "formInput",
                },
                {
                    name: "Ort",
                    type: "formInput",
                },
                {
                    name: "Land",
                    type: "formInput",
                },
                {
                    title: "Adresse bestätigen",
                    icon: "icon-left",
                    theme: "dark",
                    payload: "get_jobcenter",
                    type: "formButton",
                    pageName: "Adresse",
                },
            ],
        },
    },
    no_refugee: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Dieses Formular für die Berufsberatung ist speziell für Menschen, die Aufgrund des Krieges aus der Ukraine geflohen sind.",
            },
            {
                type: "defaultText",
                text: "Wenn Sie sich zur Arbeitssuche oder Berufsausbildung in Deutschland beraten lassen möchten finden Sie hier weitere Informationen: <br><br>Sie kommen aus dem Ausland und suchen Arbeit, dann finden Sie weitere Informationen unter: Jobs und Praktika in Deutschland finden.<br><br>Sie arbeiten bereits in Deutschland und möchten sich beruflich neu orientieren? Dann finden Sie weitere Informationen im Berufsinformationszentrum.<br>Informationen zu Weiterbildungen gibt es unter Beruflich weiterbilden.<br><br>Sie haben gerade Schule, Ausbildung oder Studium abgeschlossen und suchen Informationen zur beruflichen Orientierung oder Hilfe bei der Studien- oder Ausbildungswahl? Dann finden Sie weitere Informationen unter: Persönliche Berufsberatung.",
            },
        ],
    },
    get_jobcenter: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Sehr gut, Sie wohnen in einem Gebiet, wo wir Sie zur Arbeits- und Berufsausbildung beraten können. -- Jobcenter Daten",
            },
            {
                type: "defaultText",
                text: "Haben Sie bereits einen Beratungstermin in diesem Jobcenter vereinbart?.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "FormBTN",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ja",
                            payload: "question_form_1",
                            type: "button",
                            theme: "left",
                        },
                        {
                            title: "Nein",
                            payload: "question_form_2",
                            type: "button",
                            theme: "right",
                        },
                    ],
                },
            ],
        },
    },
    question_form_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Wunderbar, dann können wir direkt mit dem Fragebogen starten.",
            },
            {
                type: "infoText",
                text: "In der Regel dauert es ca. 15-20 min den Fragebogen auszufüllen. <br><br> Halten Sie folgendes bereit:<br><ul><li>Lebenslauf</li><li>Aufenthaltsdokumente</li></ul>",
                info: "Bitte beachten Sie, dass ich den Ausfüllstand aus Datenschutzgründen nur 24 Stunden auf Ihrem Gerät zwischenspeichern kann.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    title: "Akzeptieren und weiter",
                    icon: "icon-right",
                    payload: "start_form_dialogue_de",
                    theme: "dark",
                    type: "formButton",
                    pageName: "StartFormular",
                    stage: "Personal",
                },
            ],
        },
    },
    question_form_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Das ist kein Problem, Sie können dennoch bereits den Fragebogen ausfüllen und im Anschluss einen Termin in Ihrem zuständigen Jobcenter vereinbaren.",
            },
            {
                type: "infoText",
                text: "In der Regel dauert es ca. 15-20 min den Fragebogen auszufüllen. <br><br> Halten Sie folgendes bereit:<br><ul><li>Lebenslauf</li><li>Aufenthaltsdokumente</li></ul>",
                info: "Bitte beachten Sie, dass ich den Ausfüllstand aus Datenschutzgründen nur 24 Stunden auf Ihrem Gerät zwischenspeichern kann.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    title: "Akzeptieren und weiter",
                    icon: "icon-right",
                    payload: "start_form_dialogue_de",
                    theme: "dark",
                    type: "formButton",
                    pageName: "StartFormular",
                    stage: "Personal",
                },
            ],
        },
    },
    start_form_dialogue_de: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Um Sie richtig beraten zu können, brauchen wir bei der Arbeitsagentur einige persönliche Angaben von Ihnen.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Vorname",
                    type: "formInput",
                },
                {
                    name: "Nachname",
                    type: "formInput",
                },
                {
                    name: "Geburtsname",
                    type: "formInput",
                },
                {
                    name: "Geburtsdatum",
                    type: "formDate",
                },
                {
                    name: "Geschlecht",
                    type: "formDropdown",
                    choice: [
                        {
                            title: "weiblich",
                            payload: "weiblich",
                        },
                        {
                            title: "männlich",
                            payload: "männlich",
                        },
                        {
                            title: "divers",
                            payload: "divers",
                        },
                        {
                            title: "keine Angaben",
                            payload: "keine Angaben",
                        },
                    ],
                },
                {
                    name: "Staatsangehörigkeit",
                    type: "formDropdown",
                    choice: [
                        {
                            title: "Deutsch",
                            payload: "Deutsch",
                        },
                        {
                            title: "Ukrainisch",
                            payload: "Ukrainisch",
                        },
                        {
                            title: "Andere",
                            payload: "Andere",
                        },
                    ],
                },
                {
                    title: "Angaben bestätigen",
                    icon: "icon-left",
                    payload: "form_de_2",
                    type: "formButton",
                    pageName: "PersonalData",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Um Ihre persönliche Situation besser zu verstehen, können Sie hier Angaben zu Ihren Lebensumständen machen.",
            },
            {
                type: "defaultText",
                text: "In welcher Lebenssituation befinden Sie sich?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Status",
                    type: "button",
                    suggestion: [
                        {
                            title: "allein stehend",
                            payload: "form_de_3",
                            type: "button",
                        },
                        {
                            title: "eheähnliche/häusliche Gemeinschaft",
                            payload: "form_de_3",
                            type: "button",
                        },
                        {
                            title: "verheiratet",
                            payload: "form_de_3",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_3",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_3: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ok und haben Sie (Stief-) Kinder?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Kinder",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ja",
                            payload: "form_de_4",
                            type: "button",
                        },
                        {
                            title: "Nein",
                            payload: "form_de_6",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_6",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_4: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Wann hat Ihr jüngstes Kind Geburtstag?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Geburtstag",
                    type: "formDate",
                },
                {
                    title: "Geburtsdatum bestätigen",
                    icon: "icon-left",
                    payload: "form_de_5",
                    type: "formButton",
                    pageName: "Geburtstag_J_Kind",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_5: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Wieviele Kinder unter 15 J. leben in Ihrem Haushalt?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Kinderanzahl",
                    type: "button",
                    suggestion: [
                        {
                            title: "1",
                            payload: "form_de_6",
                            type: "button",
                        },
                        {
                            title: "2",
                            payload: "form_de_6",
                            type: "button",
                        },
                        {
                            title: "3",
                            payload: "form_de_6",
                            type: "button",
                        },
                        {
                            title: "4",
                            payload: "form_de_6",
                            type: "button",
                        },
                        {
                            title: "mehr als 4",
                            payload: "form_de_6",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_6",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_6: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Nun zur Mobilität: Haben Sie einen Führerschein?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Führerschein",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ja",
                            payload: "form_de_7",
                            type: "button",
                        },
                        {
                            title: "Nein",
                            payload: "form_de_8",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_8",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_7: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Welche Führerscheinklasse(n) haben Sie?",
                info: "Führerscheinklassen beziehungsweise Fahrerlaubnisklassen bestimmen in Deutschland welche Art von motorisier-ten Fahrzeugen Sie fahren dürfen. Bei manchen Jobs ist ein Führerschein für bestimmte Fahrzeuge notwendig oder von Vorteil.<br><br> Weitere Informationen finden Sie unter: Führerschenklassen.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Führerscheinklasse",
                    type: "formInput",
                    infoString: "z.B. Klasse B, C oder PKW",
                },
                {
                    title: "Führerscheinklasse bestätigen",
                    icon: "icon-left",
                    payload: "form_de_9",
                    type: "formButton",
                    pageName: "Führerscheinklasse",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_8: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Alles klar! Dann geht es direkt weiter mit Ihren Kontaktmöglichkeiten.",
            },
            {
                type: "defaultText",
                text: "Sollten Sie momentan nur eine temporäre Unterkunft in Deutschland haben, hilft es uns, wenn Sie uns Ihre (Mobil-) Telefon-nummer und/oder Email Adresse mit-teilen. Diese Angaben sind freiwillig. Wir behandeln Ihre Kontakt-daten vertraulich und geben diese nie an Dritte weiter.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "(Mobil-)Telefonnummer (optional)",
                    type: "formInput",
                },
                {
                    name: "E-Mail (optional)",
                    type: "formInput",
                },
                {
                    name: "Anmerkungen zur Kontaktaufnahme (optional)",
                    type: "formText",
                },
                {
                    title: "Kontaktdaten bestätigen und weiter",
                    icon: "icon-right",
                    payload: "form_de_10",
                    type: "formButton",
                    pageName: "Kontaktdaten",
                    theme: "dark",
                    stage: "Document",
                },
            ],
        },
    },
    form_de_9: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Sollten Sie momentan nur eine temporäre Unterkunft in Deutschland haben, hilft es uns, wenn Sie uns Ihre (Mobil-) Telefon-nummer und/oder Email Adresse mit-teilen. Diese Angaben sind freiwillig. Wir behandeln Ihre Kontakt-daten vertraulich und geben diese nie an Dritte weiter.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "(Mobil-)Telefonnummer (optional)",
                    type: "formInput",
                },
                {
                    name: "E-Mail (optional)",
                    type: "formInput",
                },
                {
                    name: "Anmerkungen zur Kontaktaufnahme (optional)",
                    type: "formText",
                },
                {
                    title: "Kontaktdaten bestätigen und weiter",
                    icon: "icon-right",
                    payload: "form_de_10",
                    type: "formButton",
                    pageName: "Kontaktdaten",
                    theme: "dark",
                    stage: "Document",
                },
            ],
        },
    },
    form_de_10: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Um einschätzen zu können, ob und wenn ja, welche Art der Arbeit Sie in Deutschland aufnehmen können, brauchen wir Angaben zu Ihrem Aufenthaltsstatus in Deutschland.",
            },
            {
                type: "infoText",
                text: "Was ist Ihr Aufenthaltstitle?",
                info: "Ihren Aufenthaltstitel finden Sie in Ihren Aufenthaltsdokumenten, die Sie von der Ausländerbehörde erhalten haben. Weitere Informationen finden Sie unter Einreise, Aufenthalt und Rückkehr der Webseite Germany4ukraine.de",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Visumangabe",
                    type: "button",
                    suggestion: [
                        {
                            title: "Aufenthaltserlaubnis §24 AufenthG",
                            payload: "form_de_11",
                            type: "button",
                        },
                        {
                            title: "EU-Visum",
                            payload: "form_de_11",
                            type: "button",
                        },
                        {
                            title: "gestattete Duldung",
                            payload: "form_de_11",
                            type: "button",
                        },
                        {
                            title: "Niederlassungserlaubnis",
                            payload: "form_de_11",
                            type: "button",
                        },
                        {
                            title: "Sonstige",
                            payload: "form_de_10_1",
                            type: "button",
                        },
                        {
                            title: "Ich weiß es nicht",
                            payload: "form_de_10_2",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_10_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Welchen Aufenthaltstitel haben Sie?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Aufenthaltstitel",
                    type: "formInput",
                },
                {
                    title: "Aufenthaltstitel bestätigen",
                    icon: "icon-left",
                    payload: "form_de_11",
                    type: "formButton",
                    pageName: "Aufenthaltstitel",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_10_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ihren Aufenthaltstitel finden Sie in Ihren Aufenthaltsdokumenten, die Sie von der Ausländerbehörde erhalten haben. <br><br> Weitere Informationen finden Sie unter Einreise, Aufenthalt und Rückkehr der Webseite Germany4ukraine.de. ",
            },
            {
                type: "defaultText",
                text: "Es ist wichtig, dass Sie die Angaben zu Ihrem Aufenthaltstitel zu Ihrem Beratungsgespräch mitnehmen. Ihr Aufenthaltstitel bestimmt welche Möglichkeiten Sie im deutschen Arbeitsmarkt haben.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Aufenthaltstitel",
                    type: "button",
                    suggestion: [
                        {
                            title: "Aufenthaltstitel angeben",
                            payload: "form_de_10",
                            type: "button",
                        },
                        {
                            title: "Aufenthaltstitel nachreichen",
                            payload: "form_de_13",
                            type: "button",
                            stage: "Education",
                        },
                    ],
                },
            ],
        },
    },
    form_de_11: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Bis wann ist Ihr Aufenthaltstitel gültig?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Gültigkeitsdatum",
                    type: "formDate",
                },
                {
                    name: "Gültigkeitsdatum",
                    type: "radioButton",
                    choice: [
                        {
                            title: "unbefristet",
                            payload: "form_de_12",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_12",
                        },
                    ],
                },
                {
                    title: "Gültigkeitsdatum bestätigen",
                    icon: "icon-left",
                    payload: "form_de_12",
                    type: "formButton",
                    pageName: "Gültigkeitsdatum",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_12: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Was steht zur Erwerbstätigkeit in Ihren Aufenthaltsdokumenten.?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Arbeitserlaubnis",
                    type: "button",
                    suggestion: [
                        {
                            title: "Erwerbstätigkeit gestattet",
                            payload: "form_de_13",
                            type: "button",
                            stage: "Education",
                        },
                        {
                            title: "Beschäftigung gestattet",
                            payload: "form_de_13",
                            type: "button",
                            stage: "Education",
                        },
                        {
                            title: "Beschäftigung mit Erlaubnis der Ausländerbehörde",
                            payload: "form_de_13",
                            type: "button",
                            stage: "Education",
                        },
                        {
                            title: "Erwerbstätigkeit nicht gestattet",
                            payload: "form_de_13",
                            type: "button",
                            stage: "Education",
                        },
                        {
                            title: "Sonstiges",
                            payload: "form_de_12_1",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_12_2",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_12_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Was steht zur Erwerbstätigkeit in Ihren Aufenthaltsdokumenten.?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Erwerbstätigkeitstitel",
                    type: "formInput",
                },
                {
                    title: "Angabe bestätigen",
                    icon: "icon-left",
                    payload: "form_de_13",
                    type: "formButton",
                    pageName: "Erwerbstätigkeitstitel",
                    theme: "dark",
                    stage: "Education",
                },
            ],
        },
    },
    form_de_12_2: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Es ist wichtig, dass Sie die Angaben zur Erwerbstätigkeit zu Ihrem Beratungsgespräch mitnehmen. Er bestimmt welche Möglichkeiten Sie im deutschen Arbeitsmarkt haben.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Erwerbstätigkeitstitel",
                    type: "button",
                    suggestion: [
                        {
                            title: "Angaben zur Erwerbstätigkeit angeben",
                            payload: "form_de_10",
                            type: "button",
                        },
                        {
                            title: "Angaben zur Erwerbstätigkeit nachreichen",
                            payload: "form_de_13",
                            type: "button",
                            stage: "Education",
                        },
                    ],
                },
            ],
        },
    },
    form_de_13: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Um gemeinsam mit Ihnen einen passen-den Job zu finden, sind genaue Angaben zu Ihrer schulischen und gegebenenfalls akademischen Ausbildung notwendig.",
            },
            {
                type: "defaultText",
                text: "Haben Sie einen Schulabschluss?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Schulabschluss",
                    type: "button",
                    suggestion: [
                        {
                            title: "Ja",
                            payload: "form_de_14",
                            type: "button",
                        },
                        {
                            title: "Nein",
                            payload: "form_de_14",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_14",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_14: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Und haben Sie studiert?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Studienabschluss",
                    type: "button",
                    suggestion: [
                        {
                            title: "kein Studium",
                            payload: "form_de_16",
                            type: "button",
                        },
                        {
                            title: "Studium mit Abschluss",
                            payload: "form_de_15",
                            type: "button",
                        },
                        {
                            title: "Studium ohne Abschluss",
                            payload: "form_de_14_1",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_16",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_14_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Alles klar, bitte nennen Sie mir die Fachrichtung und wie lange Sie studiert haben. ",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Studienfach",
                    type: "formInput",
                    infoString:
                        "z.B. BSc Marketing  5 Semester,  MSc Chemie Master 2 Semester",
                },
                {
                    title: "Studienangaben bestätigen",
                    icon: "icon-left",
                    payload: "form_de_16",
                    type: "formButton",
                    pageName: "Studienfach",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_15: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Alles klar, bitte nennen Sie mir Ihre akademischen Abschlüsse und die Fachrichtung.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Studium",
                    type: "formInput",
                    infoString: "z.B. BSc Business, MSc Marketing",
                },
                {
                    title: "Studienangaben bestätigen",
                    icon: "icon-left",
                    payload: "form_de_16",
                    type: "formButton",
                    pageName: "Studium",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_16: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Ok und haben Sie eine Berufsausbildung absolviert?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Ausbildung",
                    type: "button",
                    suggestion: [
                        {
                            title: "keine Berufsausbildung",
                            payload: "form_de_18",
                            type: "button",
                        },
                        {
                            title: "Berufsausbildung mit Abschluss",
                            payload: "form_de_17",
                            type: "button",
                        },
                        {
                            title: "Berufsausbildung ohne Abschluss",
                            payload: "form_de_16_1",
                            type: "button",
                        },
                        {
                            title: "keine Angabe",
                            payload: "form_de_18",
                            type: "button",
                        },
                    ],
                },
            ],
        },
    },
    form_de_16_1: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Alles klar, bitte nennen Sie mir die Fachrichtung und wie lange Sie die Ausbildung gemacht haben.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Berufsausbildung",
                    type: "formInput",
                    infoString:
                        "z.B. Bäckerin 1,5 Jahre, Bauzeichner 2,5 Jahre",
                },
                {
                    title: "Ausbildungsangaben bestätigen",
                    icon: "icon-left",
                    payload: "form_de_18",
                    type: "formButton",
                    pageName: "Berufsausbildung",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_17: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Sehr gut, bitte nennen Sie mir die Fachrichtung und Ihren Berufsabschluss.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Berufsausbildung",
                    type: "formInput",
                    infoString:
                        "z.B. Bäckerin (Meister), Bauzeichner (Geselle)",
                },
                {
                    title: "Ausbildungsangaben bestätigen",
                    icon: "icon-left",
                    payload: "form_de_18",
                    type: "formButton",
                    pageName: "Berufsausbildung",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_18: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Welchen Job würden Sie in Deutschland gerne ausüben?",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Wunschjob",
                    type: "formText",
                    infoString:
                        "z.B. Ich würde gerne als Bürokauffrau in der Lebensmittel-industrie arbeiten …",
                },
                {
                    title: "Wunschjobangaben bestätigen",
                    icon: "icon-left",
                    payload: "form_de_19",
                    type: "formButton",
                    pageName: "WunschJob",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_19: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Bitte geben Sie nun Ihren Lebenslauf mit relevanten Abschlüssen und Arbeits-erfahrung an.",
                info: "Ihre Einträge werden automatisch chronologisch gelistet. Sie können bis zu 15 Tätigkeiten eintragen.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Tätigkeitsart",
                    type: "formDropdown",
                    choice: [
                        {
                            title: "Schule",
                            payload: "Schule",
                        },
                        {
                            title: "Ausbildung",
                            payload: "Ausbildung",
                        },
                        {
                            title: "Fachhochschule",
                            payload: "Fachhochschule",
                        },
                        {
                            title: "Hochschule (Universität)",
                            payload: "Hochschule (Universität)",
                        },
                        {
                            title: "Praktikum",
                            payload: "Praktikum",
                        },
                        {
                            title: "Beschäftigung",
                            payload: "Beschäftigung",
                        },
                        {
                            title: "Sonstiges",
                            payload: "Sonstiges",
                        },
                    ],
                },
                {
                    name: "Tätigkeitsstart",
                    type: "formDate",
                },
                {
                    name: "Tätigkeitsende",
                    type: "formDate",
                },
                {
                    name: "Name der Tätigkeitsstätte",
                    type: "formInput",
                },
                {
                    name: "Tätigkeitsort (Stadt, Land)",
                    type: "formInput",
                },
                {
                    name: "Tätigkeitsbeschreibung/Qualifikation",
                    type: "formText",
                },
                {
                    title: "Tätigkeit verwerfen",
                    icon: "icon-left-x",
                    payload: "form_de_19",
                    type: "formButton",
                },
                {
                    title: "Tätigkeit bestätigen",
                    icon: "icon-left",
                    payload: "form_de_20",
                    type: "formButton",
                    pageName: "Education",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_19_1: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Tätigkeitsart",
                    type: "formDropdown",
                    choice: [
                        {
                            title: "Schule",
                            payload: "Schule",
                        },
                        {
                            title: "Ausbildung",
                            payload: "Ausbildung",
                        },
                        {
                            title: "Fachhochschule",
                            payload: "Fachhochschule",
                        },
                        {
                            title: "Hochschule (Universität)",
                            payload: "Hochschule (Universität)",
                        },
                        {
                            title: "Praktikum",
                            payload: "Praktikum",
                        },
                        {
                            title: "Beschäftigung",
                            payload: "Beschäftigung",
                        },
                        {
                            title: "Sonstiges",
                            payload: "Sonstiges",
                        },
                    ],
                },
                {
                    name: "Tätigkeitsstart",
                    type: "formDate",
                },
                {
                    name: "Tätigkeitsende",
                    type: "formDate",
                },
                {
                    name: "Name der Tätigkeitsstätte",
                    type: "formInput",
                },
                {
                    name: "Tätigkeitsort (Stadt, Land)",
                    type: "formInput",
                },
                {
                    name: "Tätigkeitsbeschreibung/Qualifikation",
                    type: "formText",
                },
                {
                    title: "Tätigkeit verwerfen",
                    icon: "icon-left-x",
                    payload: "form_de_20",
                    type: "formButton",
                },
                {
                    title: "Tätigkeit bestätigen",
                    icon: "icon-left",
                    payload: "form_de_20",
                    type: "formButton",
                    pageName: "Education",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_20: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "CV_List",
                    type: "formTable",
                    keyValue: "Education",
                },
                {
                    title: "Neuer Eintrag",
                    icon: "icon-left-p",
                    payload: "form_de_19_1",
                    type: "formButton",
                    theme: "full-right",
                },
                {
                    title: "Lebenslauf bestätigen und weiter",
                    icon: "icon-right",
                    payload: "form_de_21",
                    type: "formButton",
                    theme: "dark",
                    stage: "Language",
                },
            ],
        },
    },
    form_de_21: {
        botId: "FORM",
        messages: [
            {
                type: "infoText",
                text: "Bitte geben Sie nun Ihre Sprachkenntnisse an.",
                info: "Ihre Einträge werden automatisch chronologisch gelistet. Sie können bis zu 10 Sprachen eintragen.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Sprache",
                    type: "formDropdown",
                    choice: [
                        {
                            title: "Deutsch",
                            payload: "Deutsch",
                        },
                        {
                            title: "Englisch",
                            payload: "Englisch",
                        },
                        {
                            title: "Französisch",
                            payload: "Französisch",
                        },
                        {
                            title: "Russisch",
                            payload: "Russisch",
                        },
                        {
                            title: "Ukrainisch",
                            payload: "Ukrainisch",
                        },
                        {
                            title: "Spanisch",
                            payload: "Spanisch",
                        },
                        {
                            title: "Portugiesisch",
                            payload: "Portugiesisch",
                        },
                    ],
                },
                {
                    name: "Sprachkenntnisse",
                    type: "radioButton",
                    choice: [
                        {
                            title: "Grundkenntnisse",
                            payload: "Grundkenntnisse",
                        },
                        {
                            title: "Erweiterte Kenntnisse",
                            payload: "Erweiterte Kenntnisse",
                        },
                        {
                            title: "Verhandlungssichere Kenntnisse",
                            payload: "Verhandlungssichere Kenntnisse",
                        },
                        {
                            title: "Muttersprache",
                            payload: "Muttersprache",
                        },
                    ],
                },
                {
                    title: "Sprache verwerfen",
                    icon: "icon-left-x",
                    payload: "form_de_21",
                    type: "formButton",
                },
                {
                    title: "Sprache bestätigen",
                    icon: "icon-left",
                    payload: "form_de_22",
                    type: "formButton",
                    pageName: "Language",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_21_1: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Sprache",
                    type: "formDropdown",
                    choice: [
                        {
                            title: "Deutsch",
                            payload: "Deutsch",
                        },
                        {
                            title: "Englisch",
                            payload: "Englisch",
                        },
                        {
                            title: "Französisch",
                            payload: "Französisch",
                        },
                        {
                            title: "Russisch",
                            payload: "Russisch",
                        },
                        {
                            title: "Ukrainisch",
                            payload: "Ukrainisch",
                        },
                        {
                            title: "Spanisch",
                            payload: "Spanisch",
                        },
                        {
                            title: "Portugiesisch",
                            payload: "Portugiesisch",
                        },
                    ],
                },
                {
                    name: "Sprachkenntnisse",
                    type: "radioButton",
                    choice: [
                        {
                            title: "Grundkenntnisse",
                            payload: "Grundkenntnisse",
                        },
                        {
                            title: "Erweiterte Kenntnisse",
                            payload: "Erweiterte Kenntnisse",
                        },
                        {
                            title: "Verhandlungssichere Kenntnisse",
                            payload: "Verhandlungssichere Kenntnisse",
                        },
                        {
                            title: "Muttersprache",
                            payload: "Muttersprache",
                        },
                    ],
                },
                {
                    title: "Sprache verwerfen",
                    icon: "icon-left-x",
                    payload: "form_de_22",
                    type: "formButton",
                },
                {
                    title: "Sprache bestätigen",
                    icon: "icon-left",
                    payload: "form_de_22",
                    type: "formButton",
                    pageName: "Language",
                    theme: "dark",
                },
            ],
        },
    },
    form_de_22: {
        botId: "FORM",
        answerBy: {
            type: "formInput",
            elements: [
                {
                    name: "Sprachen Liste",
                    type: "formTable",
                    keyValue: "Language",
                },
                {
                    title: "Neuer Eintrag",
                    icon: "icon-left-p",
                    payload: "form_de_21_1",
                    type: "formButton",
                    theme: "full-right",
                },
                {
                    title: "Sprachen bestätigen und Formular absenden",
                    icon: "icon-right",
                    payload: "send_form",
                    type: "formButton",
                    pageName: "FormularAbschluss",
                    theme: "dark",
                    stage: "Finish",
                },
            ],
        },
    },
    send_form: {
        botId: "FORM",
        messages: [
            {
                type: "defaultText",
                text: "Vielen Dank, wir haben Ihr Dokument erstellt!<br>Sie können den Assistenten nun schließen.",
            },
        ],
        answerBy: {
            type: "formInput",
            elements: [],
        },
    },
};
